import Environmental from './Environmental';
import Geotechnical from './Geotechnical';
import LandRights from './LandRights';
import Utilities from './Utilities';

export function TabDetails() {
  return (
    <div className="text-base">
      <Utilities />
      <LandRights />
      <Geotechnical />
      <Environmental />
    </div>
  );
}
